module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-1-2-1d1d0d603b9a586d46cbefe870d08543.jpg";